<template>
  <div class="m-card">
    <div class="header">
      <h1 style="font-weight: bold">Vibration Detection</h1>
      <!-- <h5>Status</h5>
      <h1 style="font-weight: bold; color: #32c040">{{ status }}</h1> -->
      <br>
    </div>
    <div class="content">
      <img
        style="width: 100%"
        src="@/assets/images/hino element/img_vira.gif"
        alt=""
      />
      <div class="vibra-axis">
        <div class="axis">
          <h5 class="x-axis">X-Axis</h5>
          <ul>
            <li>
              <span class="speed">Acceleration</span>
              <span>{{dataVibration.x.acceleration.toFixed(2)}} <sub>m/s<sup>2</sup></sub></span>
            </li>
            <li>
              <span class="freq">Velocity</span>
              <span>{{dataVibration.x.velocity.toFixed(2)}}  <sub>m/s</sub></span>
            </li>
          </ul>
        </div>
        <div class="axis">
          <h5 class="y-axis">Y-Axis</h5>
          <ul>
            <li>
              <span class="speed">Acceleration</span>
              <span>{{dataVibration.y.acceleration.toFixed(2)}}  <sub>m/s</sub><sup>2</sup></span>
            </li>
            <li>
              <span class="freq">Velocity</span>
              <span>{{dataVibration.y.velocity.toFixed(2)}}  <sub>m/s</sub></span>
            </li>
          </ul>
        </div>
        <div class="axis">
          <h5 class="z-axis">Z-Axis</h5>
          <ul>
            <li>
              <span class="speed">Acceleration</span>
              <span>{{dataVibration.z.acceleration.toFixed(2)}}  <sub>m/s</sub><sup>2</sup></span>
            </li>
            <li>
              <span class="freq">Velocity</span>
              <span>{{dataVibration.z.velocity.toFixed(2)}}  <sub>m/s</sub></span>
            </li>
          </ul>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            font-size: 0.7rem;
          "
        >
          <div class="date">Date : {{ time_stamp.split(' ')[0] }}</div>
          <div class="date">time : {{ time_stamp.split(' ')[1] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    dataVibration:Object,
    time_stamp:String,
  },
  data() {
    return {
      status: "Normal",
      today: this.$moment().format("YYYY-MM-DD"),
      time: this.$moment().format("hh:mm:ss"),
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  text-align: center;
  color: var(--text-color-2);
}
.content {
  display: grid;
  grid: auto/50% auto;
  gap: 10px;
}
.axis {
  display: flex;
  flex-direction: column;
  align-items: center;
}
ul {
  list-style-type: none;
  width: 100%;
  li {
    display: grid;
    grid: auto/50% auto;
    gap: 5px;
    span {
      &:nth-child(1) {
        text-align: end;
      }
    }

    // margin-bottom: 1rem;
    // font-size: 1rem;
  }
}
sub {
  color: var(--text-color-2);
}
.date {
  color: var(--text-color-2);
}
.speed {
  color: #ffa807;
}
.freq {
  color: #8f07ff;
}
.x-axis {
  padding: 5px;
  border-radius: 20px;
  background: linear-gradient(90deg, #cc7400 0%, #f1db17 100%);
}
.y-axis {
  padding: 5px;
  border-radius: 20px;
  background: linear-gradient(90deg, #00cc7e 0%, #b0f117 100%);
}
.z-axis {
  padding: 5px;
  border-radius: 20px;
  background: linear-gradient(90deg, #da2acb 0%, #d3982b 100%);
}
</style>